import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CommondataService } from '../../source/services/games/commondata.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent {
  @Input() isGameLaunch:boolean = false;
  isLoading:boolean = false;

  constructor(private commonSvc:CommondataService){}

  ngOnInit(){
    this.commonSvc.isLoading$.subscribe(res => this.isLoading = res)
  }

}
